module.exports = __webpack_public_path__ + "img/symbol_8.f3ca9014.png";